import $ from 'jquery';
import { find } from 'lodash';
import dispatcher from '../../lib/dispatcher';
import { EVENTS, DEFAULT_PROVINCE_CODE } from '../../lib/constants';
import {associationsFallbackData, associationsFalbackData_fr} from '../../data/associations';

const handleDealerLocatorToggle = (provinceCode, postalCode) => {
  const $dlPostalCodeInput = $('.dealer-locator .input-post-code');
  const $dlPostalCodeGoBtn = $('.find-dealers-by-postal');
  //load results for postal code if postal code is present
  if (postalCode !== '') {
    if ($dlPostalCodeInput.length === 0)
      return;
    $dlPostalCodeInput.val(`${postalCode}`).trigger('keyup');
    $dlPostalCodeInput.siblings('.input-btn').addClass('alt-color');
    $dlPostalCodeGoBtn.trigger('click');
  }
  //if no postal code, load provinces
  else {
    $dlPostalCodeInput.val('').trigger('keyup')
    const $dlProvinceDropdown = $('.selectboxit');
    if ($dlProvinceDropdown.length > 0)
    {
      window.selectDealerLocatorProvince(provinceCode);
    }
    else {
      $('.locate-dealer-dropdown').val(`${provinceCode}`)
    }
    if (provinceCode === DEFAULT_PROVINCE_CODE) {
      $('.dealer-results').hide();
      const $titleHeader = $('.dealers.page-header-title');
      $titleHeader.text($titleHeader.data('origTitle'));
    }
  }
}

const migrationsDesktop = {
  init(config) {
    dispatcher.on(EVENTS.ProvinceSelected, ({ province, code, postalCode }) => {
      this.updatePaymentCalculator(code);
      this.updateSpecialOffers(code, postalCode, config);
      this.updateDealersLocator(code, postalCode);
      this.updateTireWizard(code);
    });
  },
  getAssociations(config) {
    //TODO: need to get associations fro API
    var fallbackAssociations = config.language === 'en' ? associationsFallbackData : associationsFalbackData_fr;
    return fallbackAssociations;
  },

  updatePaymentCalculator(province) {
    const $financeCalculator = $('#finance_calculator');

    if ($('#province', $financeCalculator).length > 0) {
      let provinceCode = province;
      if (['', 'NT', 'NU'].indexOf(province) >= 0) {
        provinceCode = 'ON';
      }
      if (window.provinceDropdownChange) {
        window.provinceDropdownChange(provinceCode);
      }
    }
  },
  updateSpecialOffers(provinceCode, postalCode, config) {
    if ($('#special-offers-page .no-association').length > 0) {
      if (provinceCode === DEFAULT_PROVINCE_CODE)
        return;
      const associations = this.getAssociations(config);
      const association = find(associations, {Province: {Abbreviation: provinceCode}});
      if (association)
      {
        let url = association.Url;
        if (window.location.pathname.indexOf(url) < 0)
          window.location.href = url;
      }
    } else if ($('#special-offers-page').length > 0) {
      handleDealerLocatorToggle(provinceCode, postalCode);
    }
  },
  updateDealersLocator(provinceCode, postalCode) {
    //dealer locator
    if ($('#dealer-locator-page').length > 0) {
      handleDealerLocatorToggle(provinceCode, postalCode);
    }
  },
  updateTireWizard(provinceCode) {
    //Tire wizard
    if ($('#tire-finder-dealer-collection-primary').length > 0) {
      if ($('#tire-finder-dealer-collection-primary').css('display') === 'block') {
        const provinceItem = $('.province-selector-form .dropdown_list .province[rel="' + provinceCode + '"]');
        $('.dropdown_container.vehicle_box.dealer_region_box').hide();
        if (provinceItem.length > 0) {
          $('.tire-province-selector span').text($(provinceItem).html());
          $('.tire-wizard-search-results').show();
          if (window.tireSelectionController) {
            window.tireSelectionController.getDealerCollectionController().bindDealersByRegion(provinceCode);
          }
        } else {
          const title = $('.tire-province-selector').data('title');
          $('.tire-province-selector span').text(title || 'Region');
          $('.tire-wizard-search-results').hide();
        }
      }
    }
  },
}

export default migrationsDesktop;



// WEBPACK FOOTER //
// ./src/apps/acuraca/desktop.migrations.js